import React from 'react';
import { IconBlock } from './styles';

interface Props {
  children: React.ReactNode;
  size?: 'small' | 'large';
  backgroundColor?: string;
}

const ViewIcon: React.FC<Props> = ({ children, size = 'large', backgroundColor }) => {
  return (
    <IconBlock size={size} backgroundColor={backgroundColor}>
      {children}
    </IconBlock>
  );
};

export default ViewIcon;
